import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import ReactDataGrid from 'react-data-grid';
import { formatDate } from '../../Util';
import 'bootstrap/dist/css/bootstrap.css';

class ProjectsBoard extends Component {

	constructor(props,context) {
	    super(props,context);
	    this._columns = [
	      {
	        key: 'id',
	        name: 'ID',
	        resizable: true,
	        locked: true,
	        formatter: this.makeIdClickable
	      },
	      {
	        key: 'title',
	        name: 'Title',
	        width: 180,
	        resizable: true,
	        sortable: true
	      },
	      {
	        key: 'name',
	        name: 'Name',
	        width: 160,
	        resizable: true,
	        sortable: true
	      },
	      {
	        key: 'email',
	        name: 'Email',
	        width: 200,
	        resizable: true,
	        sortable: true
	      },
	      {
	        key: 'created_at',
	        name: 'Date',
	        width: 100,
	        resizable: true,
	        sortable: true,
	        formatter: this.formatBoardDate
	      },
	      {
	        key: 'amount',
	        name: 'Amount',
	        width: 120,
	        resizable: true,
	        sortable: true,
	        formatter: this.formatAmount
	      }
	    ];
	    let originalRows = this.props.items;
	    let rows = originalRows.slice(0);
	    this.state = { originalRows, rows };
	    this.rowGetter = this.rowGetter.bind(this);
	    this.handleGridSort = this.handleGridSort.bind(this);
	    this.formatBoardDate = this.formatBoardDate.bind(this);
	    this.makeIdClickable = this.makeIdClickable.bind(this);
	    this.formatAmount = this.formatAmount.bind(this);
	}

	formatBoardDate(value){
		return formatDate(value.value);
	}

	formatAmount(value){
		if(value.value === null){
			return "0€";
		}else{
			return value.value + "€";
		}
	}

	makeIdClickable(value){
		return <Link to={'/projects/'+value.value} key={value.value}>{value.value}</Link>
	}

	handleGridSort(sortColumn, sortDirection){
	    const comparer = (a, b) => {
	      if (sortDirection === 'ASC') {
	        return (a[sortColumn] > b[sortColumn]) ? 1 : -1;
	      } else if (sortDirection === 'DESC') {
	        return (a[sortColumn] < b[sortColumn]) ? 1 : -1;
	      }
	    };

	    const rows = sortDirection === 'NONE' ? this.state.originalRows.slice(0) : this.state.rows.sort(comparer);

	    this.setState({ rows });
	}

	rowGetter(i){
	    return this.state.rows[i];
	}

	render() {
		return (
			<div className="adminBoard">
				<ReactDataGrid
			        onGridSort={this.handleGridSort}
			        columns={this._columns}
			        rowGetter={this.rowGetter}
			        rowsCount={this.state.rows.length}
			        minHeight={400} />
			</div>
		);
	}
}

export default ProjectsBoard;



// WEBPACK FOOTER //
// ./src/components/Admin/TransactionsBoard.js